export default __webpack_public_path__ + "static/media/managing_ccp_data_not_found.e9190254.svg";